import { motion } from "framer-motion";
import { PawPrint, Heart, Bone } from "./Doodles";

const POINTS = [
  "Weekend doghouse build days around San Diego",
  "Every doghouse donated to local San Diego dog shelters",
  "Open to local high school and college students",
  "No experience needed — we teach you everything",
];

const SanDiego = () => (
  <section
    id="san-diego"
    data-testid="san-diego-section"
    className="relative scroll-mt-24 border-t-2 border-[#16294B] bg-[#FBF3E3] py-24 md:py-32"
    aria-label="Dog shelter volunteering in San Diego"
  >
    <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 sm:px-8 md:grid-cols-2 md:gap-16">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="flex items-center gap-4">
          <Bone className="h-8 w-8 -rotate-12" color="#E63946" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#E63946]">Local love</span>
        </div>
        <h2 className="mt-4 font-display text-5xl leading-tight text-[#16294B] md:text-6xl">
          Dog shelter volunteering in <span className="hl-underline">San Diego</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-[#4A5568] md:text-lg">
          Project Archie is a student-led community service initiative bringing hands-on
          dog shelter volunteering to San Diego. Our student volunteers — from local
          high schools and colleges around San Diego — gather for build days, pick up real
          woodworking skills, and hand-deliver every finished doghouse to a local San Diego dog shelter.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[#4A5568] md:text-lg">
          If you've been looking for a meaningful way to give back to the San Diego
          community, learn practical skills, and help shelter dogs find comfort while they
          wait for their forever homes — this is it.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, rotate: 4, y: 40 }}
        whileInView={{ opacity: 1, rotate: 2, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative border-2 border-[#16294B] bg-[#F4E9D2] p-7 shadow-[8px_8px_0_0_#16294B] md:p-9"
      >
        <span className="absolute -top-5 -right-3 rotate-12" aria-hidden="true">
          <Heart className="h-10 w-10" />
        </span>
        <h3 className="font-display text-2xl text-[#16294B] md:text-3xl">Why San Diego students join us</h3>
        <ul className="mt-6 space-y-4">
          {POINTS.map((point, i) => (
            <motion.li
              key={point}
              data-testid={`san-diego-point-${i}`}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="flex items-start gap-3"
            >
              <PawPrint className="mt-0.5 h-6 w-6 shrink-0" color={i % 2 === 0 ? "#3B82F6" : "#E63946"} />
              <span className="text-sm font-medium leading-relaxed text-[#16294B] md:text-base">{point}</span>
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);

export default SanDiego;
